import { GetAllSites } from '@/api/fe-api/view/queries/get-all-sites';
import { FieldSelect } from '@/components/looker/field-select';
import { CustomerType } from '@/entities/customer-type';
import { useMe } from '@/hooks/use-me';
import { WorkstreamsQuery } from '@/project-management/queries/workstreams.query';
import { ListTasks } from '@/task-manager/api/queries/list-tasks';

export type WorkstreamFilterProps = {
  assetId?: string;
  value?: string;
  filters: ListTasks.Filters;
  onChange: (value?: string) => void;
};

export function WorkstreamFilter({
  assetId,
  value,
  filters,
  onChange,
}: WorkstreamFilterProps) {
  let siteId = assetId;
  const { config } = useMe();

  // TODO: Replace this when we filter using ACCURE ID instead of frontend ID
  const assets =
    GetAllSites.useQuery({
      enabled: !assetId && config.type === CustomerType.BESS,
    }).data ?? [];

  if (assets.length > 0 && filters.groupId) {
    siteId = assets.find(
      (asset) => asset.fullFrontendId === filters.groupId,
    )?.id;
  }

  const workstreams =
    WorkstreamsQuery.useQuery({ siteId }).data?.workstreams ?? [];

  return (
    <FieldSelect
      data-testid="workstream-filter"
      isFilterable={true}
      isClearable={true}
      label="Workstream"
      placeholder="Filter by workstream"
      value={value}
      options={
        workstreams.map((workstream) => ({
          label: workstream.name,
          value: workstream.id,
        })) ?? []
      }
      onChange={onChange}
    />
  );
}
